import styled from 'styled-components';
import { Theme } from 'styles/theme';
import { readOurReviews } from 'styles/widgets/readOurReviews';
import { commonHighlightCardsStyles, contentHighlightCard, topHighlightCard } from 'styles/widgets/highlightCards';

// eslint-disable-next-line import/prefer-default-export
export const ContentWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  margin: auto;
  margin-bottom: calc(var(--Section-Margin) * -1);
    
  .spinning-loader {
    margin: auto;
  }
  gap: var(--Section-Margin);

  ${readOurReviews}
`;

export const Wrapper = styled.div<{ theme: Theme }>`
  ${commonHighlightCardsStyles};
  ${topHighlightCard};
  ${contentHighlightCard};
`;
